import { createFileRoute } from '@tanstack/react-router';
import { HomeGate } from '@/features/account/shell/HomeGate';
import EditPhotoPage from '@/features/account/profile/edit-photo';
import { IdentityRouteGuard } from '@/features/account/identity-confirmation';
import { ensureOnboardingProgressLoaded } from '@/features/account/onboarding/shared/ensure-onboarding-progress.loader';

export const Route = createFileRoute('/perfil/foto/')({
  component: () => (
    <HomeGate>
      <IdentityRouteGuard target="photo">
        <EditPhotoPage />
      </IdentityRouteGuard>
    </HomeGate>
  ),
  loader: ({ context }) => ensureOnboardingProgressLoaded(context),
});
